module.exports = __webpack_public_path__ + "img/ai-icon.6f3e5dd9.png";